export default "__VITE_ASSET__BO4$TQb7__"